import * as React from "react";
import { Context } from "@grandvisionhq/carts-v2";
import { toast } from "@grandvisionhq/common";
import { useMutation } from "@grandvisionhq/graphql";
import { useDispatchTrackErrorEvent } from "@grandvisionhq/svc-tealium/events";
import { useMutationConfig } from "./use-mutation-config.js";
import { getFlattenedCartFailureErrorCodes } from "../../../../utils/utils/get-flattened-cart-error-codes.js";
import { errorsMapping } from "../../../../mappers/mappers/errors-mapping.js";
import { SET_SHIPPING_STATE } from "../../../../operations/mutations/operations/mutations/set-shipping-state.js";
const useSetShippingMethodState = ({
  onError,
  onCompleted
} = {}) => {
  const { cart } = Context.useCart();
  const dispatchTrackErrorEvent = useDispatchTrackErrorEvent();
  const handleOnCompleted = React.useCallback(
    (responseData) => {
      let result;
      if ("setShippingState" in responseData) {
        result = responseData.setShippingState;
        if (result.failures?.length) {
          const errorCodes = getFlattenedCartFailureErrorCodes(result.failures);
          onError?.({ reason: "MUTATION" });
          errorCodes.forEach((error) => toast.failed(error));
        }
        if (result.success) {
          onCompleted?.(result.cart.hasAlternativeShippingState ? result.cart.id : void 0);
        }
      }
    },
    [onCompleted, onError]
  );
  const handleOnError = React.useCallback(() => {
    onError?.({ reason: "MUTATION" });
    dispatchTrackErrorEvent(
      () => Promise.resolve({
        Error_Source: "Server",
        Error_Code: "Set shipping state error",
        Error_Details: "Mutation failed",
        Error_Message: errorsMapping.SOMETHING_WENT_WRONG
      })
    );
    toast.failed(errorsMapping.SOMETHING_WENT_WRONG);
  }, [dispatchTrackErrorEvent, onError]);
  const { mutationOptions } = useMutationConfig({
    onError: handleOnError,
    onCompleted: handleOnCompleted
  });
  const [mutationCallback, mutation] = useMutation(SET_SHIPPING_STATE, {
    ...mutationOptions,
    fetchPolicy: "no-cache"
  });
  const setShippingMethodState = React.useCallback(
    async (countryCode, postalCode) => {
      const cartId = cart?.id;
      if (!cartId) {
        return;
      }
      await mutationCallback({
        variables: {
          shippingStateInput: {
            cartId,
            countryCode,
            postalCode
          }
        },
        refetchQueries: ["GetCart", "ShippingMethodsForCart"]
      });
    },
    [cart?.id, mutationCallback]
  );
  return {
    setShippingMethodState,
    isUpdating: mutation.loading,
    updateError: mutation.error
  };
};
export {
  useSetShippingMethodState
};
//# sourceMappingURL=use-set-shipping-method-state.js.map
